<template>
  <div style="background-color: #fff">
    <br />
    <div class="box">
      <van-cell :title="title">
        <van-loading v-show="isPay == 'processing'" color="#62b900" size="24" />
        <van-icon v-show="isPay == 'paySuccessful'" name="passed" size="24" color="#62b900" />
      </van-cell>
      <van-cell title="支付费用" :value="this.StrategyInfo.Price"></van-cell>
      <van-cell title="存储时间" :value="StrategyDate"></van-cell>
    </div>
    <div style="width: 100%; text-align: center">
      <van-button v-show="isPay == 'paySuccessful'" class="go_back" @click.native="goBack"
        >完成({{ countdown }})</van-button
      >
      <van-button v-show="isPay == 'processing'" class="go_back" @click.native="goBack">返回</van-button>
    </div>
    <van-toast v-model="messageInfo.isShow" type="text" width="20em">{{ messageInfo.message }}</van-toast>
    <van-loading type="spinner" class="loading" v-show="loading" />
  </div>
</template>

<script>
import { WXH5Pay,GetWxH5PayResult,GetPayParameterByType,UpdateCloudImagePaymentOrderPaymentStatus } from '@/api/CloudFilmService'
import enums from '@/utils/enums'
import { GetGoBackUrlParms,GetWXJsApiPayInfo } from '../../utils/cacheUtils'
import { DecryptAES, EncryptAES } from '../../utils/stringUtils'
export default {
  data() {
    return {
      messageInfo: { isShow: false, message: '' },
      title: '正在支付',
      StrategyInfo: { Price: 128.8, StorageDuration: 1, StorageDurationUnit: 0 },
      //加载
      loading: false,
      StrategyDate: '1天',
      IP: '',
      isPay: 'processing',
      countdown: 3,//3秒之后跳转到报告详情页面
    }
  },
  created() {
    this.getIpAddress()
    if(this.$route.params.key){
      this.StrategyInfo = JSON.parse(this.$route.params.key)
    }
  },
  mounted() {
    //微信支付
    if(this.IsWxBrowser()){
      //JSAPI支付
      this.JSApiPay()
    }else{
      //H5支付
      if(localStorage.getItem('OutTradeNo')){
        this.OrderQuery(DecryptAES(localStorage.getItem('OutTradeNo')))
      }else {
        this.h5Pay()
      }
    }
  },
  methods: {
    //判断是否为微信浏览器
    IsWxBrowser(){
      let ua=navigator.userAgent.toLowerCase()
      return /micromessenger/.test(ua)?true:false
    },
    //H5支付 判断Android或者IOS系统
    appSource() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        return enums.MobileSystemType.IOS.value
      } else {
        return enums.MobileSystemType.Android.value
      }
    },
    // H5支付 获取IP地址
    getIpAddress() {
      // eslint-disable-next-line no-undef
      this.IP = returnCitySN['cip']
    },
    //H5支付
    h5Pay() {
      this.StrategyDate =
        this.StrategyInfo.StorageDuration +
        (this.StrategyInfo.StorageDurationUnit == 0 ? '天' : this.StrategyInfo.StorageDurationUnit == 1 ? '月' : '年')
      this.loading = true
      var parameter = {
        TotalFee: this.StrategyInfo.Price + '元',
        ClientIP: this.IP,
        OperatingSystemType: this.appSource(),
        cloudImagePaymentOrderInfo: {
          OutTradeNo:this.moment().format('YYYY-MM-DD HH:mm:ss'),
          CloudImagePatientID: this.$route.params.PatientID,
          CloudImagePaymentStrategyID: this.StrategyInfo.ID,
          CloudImageReportID: this.$route.params.ID,
          PaymentWay: enums.PaymentWay.微信.value,
        },
      }
      WXH5Pay({ parameter: parameter, HospitalID: this.StrategyInfo.Hospital.ID }).then((response) => {
          if (response.Success) {
            window.location.href = response.Result[0]
            localStorage.setItem('OutTradeNo', EncryptAES(response.Result[1]))
            localStorage.setItem('HospitalID', EncryptAES(this.StrategyInfo.Hospital.ID))
            localStorage.setItem('TotalFee', EncryptAES( this.StrategyInfo.Price + '元'))
          } else {
            this.messageInfo = { isShow: true, message: response.Reason }
          }
        })
        .catch(() => {
          this.messageInfo = { isShow: true, message: '连接失败，请检查网络' }
        })
    },
    //查询订单是否支付成功
    OrderQuery(parameter) {
      this.StrategyInfo.Price=DecryptAES(localStorage.getItem('TotalFee'))
      //提交支付成功业务
      GetWxH5PayResult({OutTradeNo: parameter,HospitalID:DecryptAES(localStorage.getItem('HospitalID'))}).then((response) => {
        if (response.Success) {
          this.title="支付成功"
          this.isPay="paySuccessful"
        } else {
          this.title="支付失败"
          this.messageInfo = {isShow: true,message: '支付失败,正在返回中...' };
        }
        this.BackWait()
      }).catch(() => {
        this.title="支付失败"
        this.messageInfo = {isShow: true,message: '连接失败，请检查网络',};
        this.BackWait()
      });
    },
    onBridgeReady (options) {
      WeixinJSBridge.invoke("getBrandWCPayRequest",{
          appId: options.appId, //公众号名称，由商户传入
          timeStamp: options.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: options.nonceStr, //随机串
          package: options.package,
          signType: options.signType, //微信签名方式：
          paySign: options.paySign, //微信签名
          notifyurl:options.notifyurl
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            var info= {
              OutTradeNo:DecryptAES(localStorage.getItem('OutTradeNo')) ,
              PaymentStatus: enums.PaymentStatus.完成支付
            }
            //提交支付成功业务
            UpdateCloudImagePaymentOrderPaymentStatus(info).then((response) => {
              if (response.Success) {
                this.title="支付成功"
                this.isPay="paySuccessful"
                this.BackWait()
              } else {
                this.title="支付失败"
                this.messageInfo = {isShow: true,message: '连接失败，请检查网络',};
                this.BackWait()
              }
            });
          }
        }
      );
    },
    //JSAPI支付
    async JSApiPay(){
      var code = this.getUrlParam("code")
      var PayInfo=JSON.parse(DecryptAES(GetWXJsApiPayInfo()))
      var lastOrderNumber = DecryptAES(localStorage.getItem('OutTradeNo')) //上次的商户订单号 
      var local = window.location.href
      this.StrategyInfo=PayInfo.StrategyInfo
      if (lastOrderNumber === null ||lastOrderNumber !== PayInfo.lastOrderNumber) {
        //记录上次的价格
        window.location.href ="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxac585d4f2edd9c1d&redirect_uri=" +
          encodeURIComponent(local) + "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
        localStorage.setItem('OutTradeNo', EncryptAES(PayInfo.lastOrderNumber))
      } else {
        this.loading = true;
        //获取用户code
        //获取上次存储的微信支付信息
        var wxPayInfo = null;
        //第一次使用获取，第二次使用，使用缓存，否则报错
        if (lastOrderNumber !== null &&lastOrderNumber === PayInfo.lastOrderNumber) {
          wxPayInfo = localStorage.getItem('Code')
        }

        if (wxPayInfo === null) {
          //上次价格不这次价格不一致，重新提交订单
          var parameter = {code: code,info:this.StrategyInfo,OutTradeNo:lastOrderNumber,ClientIP:this.IP}
          alert(JSON.stringify(parameter))
          //获取微信code
          GetPayParameterByType(parameter).then((response) => {
              //隐藏加载
              this.loading = false;
              if (response.IsSuccessful) {
                //处理业务
                 localStorage.setItem('Code', response.Result);
                //记录本次商户订单号
                localStorage.setItem('OutTradeNo', EncryptAES(lastOrderNumber))
                let that = this;
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener("WeixinJSBridgeReady",that.onBridgeReady(response.Result),false)
                  } else if (document.attachEvent) {
                    document.attachEvent("WeixinJSBridgeReady",that.onBridgeReady(response.Result))
                    document.attachEvent("onWeixinJSBridgeReady",that.onBridgeReady(response.Result))
                  }
                } else {
                  that.onBridgeReady(response.Result);
                }
              } else {
                //请求失败
                this.messageInfo = {isShow: true,message: "请求失败"}
              }
            }).catch(() => {
              this.loading = false;
            });
        } else {
          let that = this;
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener("WeixinJSBridgeReady",that.onBridgeReady(wxPayInfo),false)
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady",that.onBridgeReady(wxPayInfo))
              document.attachEvent("onWeixinJSBridgeReady",that.onBridgeReady(wxPayInfo))
            }
          } else {
            that.onBridgeReady(wxPayInfo)
          }
        }
      }
    },
    getUrlParam (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "g");
      let url = window.location.href.split("#")[0];
      let search = url.split("?")[1];

      if (search) {
        var r = search.substr(0).match(reg);
        var code = r[r.length - 1].replace("code=", "");
        code = code.replace(/&/g, "");
        if (r !== null) return unescape(code);
        return null;
      } else {
        return null;
      }
    },
    goBack() {
     this.$router.replace({path:'/reportView?'+GetGoBackUrlParms()})
    },
    BackWait(){
      this.countdown = 3
      this.loading = false
      var timer = setInterval(() => {
        this.countdown--
        if (this.countdown == -1) {
          this.countdown = 0
          clearInterval(timer)
          this.goBack()
        }
      }, 1000)
    }
  },
}
</script>

<style scoped>
.box {
  overflow: hidden;
  margin: 0 0 15px;
  border-radius: 10px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
}
.go_back {
  width: 150px;
  height: 40px;
  color: #62b900;
  border-radius: 8px;
  border-color: #62b900;
}
.van-cell {
  padding: 12px 20px;
}
.van-cell__title,
.van-cell__value {
  flex: none;
}
.van-cell__title {
  margin-right: 30px;
}
.van-cell:nth-child(1) .van-cell__value {
  display: flex;
}
.van-cell__value {
  min-width: 25px;
  text-align: center;
}
</style>
